import debounce from 'lodash/debounce';
import Vue from 'vue';

const createInitialSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

const vm = Vue.observable(createInitialSize());

const debouncedResizeHandler = debounce(() => {
  vm.width = window.innerWidth;
  vm.height = window.innerHeight;
}, 100);

// This listener won't dissapear
// eslint-disable-next-line listeners/no-missing-remove-event-listener
window.addEventListener('resize', debouncedResizeHandler, { passive: false });

const mixin = {
  computed: {
    $windowWidth() {
      return vm.width;
    },
    $windowHeight() {
      return vm.height;
    },
  },
  methods: {
    /**
     * Check whether an element is partially visible in Viewport (even by a few
     * pixels).
     * @param {Element} element - Element of the DOM to check
     * @returns {boolean} - true if is visible; otherwise, false
     */
    $isInViewport(element) {
      const {
        top, right, bottom, left,
      } = element.getBoundingClientRect();
      const windowTop = 0;
      const windowBottom = this.$windowHeight;
      const windowLeft = 0;
      const windowRight = this.$windowWidth;
      return !(
        top > windowBottom
        || right < windowLeft
        || bottom < windowTop
        || left > windowRight
      );
    },
  },
};

export default {
  install(vueApp) {
    vueApp.mixin(mixin);
  },
};
